import { SxProps, Theme } from "@mui/material/styles";

export const sloganText: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "800",
    fontSize: {
        xs: "1.75rem",
        sm: "2.25rem",
        md: "2.75rem",
    },
    lineHeight: 1.3,
    marginBottom: {
        xs: "24px",
        md: "32px",
    },
    color: "white",
    letterSpacing: "0.02em",
    textShadow: "0 2px 10px rgba(0,0,0,0.5)",
};

export const welcomeText: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "500",
    fontSize: {
        xs: "1.375rem",
        sm: "1.625rem",
        md: "1.875rem",
    },
    lineHeight: 1.4,
    marginBottom: {
        xs: "50px",
        md: "70px",
    },
    color: "rgba(255, 255, 255, 0.9)",
    letterSpacing: "0.01em",
};

export const highlightNumber: SxProps<Theme> = {
    color: "#B4A36E",
    fontWeight: "900",
    fontSize: "1.15em",
};
